"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); } /* eslint-disable react/no-danger */
var testId = 'social-media-analytics';

// the script contents were copied straight from the JIRA ticket
var SocialMediaTracker = /*#__PURE__*/function (_React$Component) {
  function SocialMediaTracker() {
    _classCallCheck(this, SocialMediaTracker);
    return _callSuper(this, SocialMediaTracker, arguments);
  }
  _inherits(SocialMediaTracker, _React$Component);
  return _createClass(SocialMediaTracker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        linkedInId = _this$props.linkedInId,
        fbId = _this$props.fbId,
        dryRun = _this$props.dryRun;
      if (!(0, _utils.canUseDOM)() || dryRun) {
        return;
      }
      if (linkedInId) {
        // This code as taken from https://jira.concur.com/browse/APPMGT-1975 and ES6-ified
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(linkedInId);
        var s = document.getElementsByTagName('script')[0];
        var b = document.createElement('script');
        b.type = 'text/javascript';
        b.async = true;
        b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
        s.parentNode.insertBefore(b, s);
      }
      if (fbId) {
        !function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = !0;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = !0;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t, s);
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', fbId);
        fbq('track', 'PageView');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        fbId = _this$props2.fbId,
        linkedInId = _this$props2.linkedInId;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!linkedInId && /*#__PURE__*/_react.default.createElement("noscript", {
        "data-test-id": testId
      }, /*#__PURE__*/_react.default.createElement("img", {
        height: "1",
        width: "1",
        style: {
          display: 'none'
        },
        alt: "",
        src: "https://px.ads.linkedin.com/collect/?pid=".concat(linkedInId, "&fmt=gif")
      })), !!fbId && /*#__PURE__*/_react.default.createElement("noscript", {
        "data-test-id": testId
      }, /*#__PURE__*/_react.default.createElement("img", {
        height: "1",
        width: "1",
        style: {
          display: 'none'
        },
        src: "https://www.facebook.com/tr?id=".concat(fbId, "&ev=PageView&noscript=1"),
        alt: ""
      })));
    }
  }]);
}(_react.default.Component);
SocialMediaTracker.propTypes = {
  dryRun: _propTypes.default.bool,
  fbId: _propTypes.default.string,
  linkedInId: _propTypes.default.string
};
SocialMediaTracker.defaultProps = {
  fbId: '908266409244597',
  linkedInId: '1999076'
};
var _default = exports.default = SocialMediaTracker;